import { Component, Inject, Input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { Classifier } from '@nano/common/classifier';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';

@Component({
  selector: 'app-service-charge-details',
  templateUrl: './service-charge-details.component.html',
  standalone: false
})
export class ServiceChargeDetailsComponent {
  @Input() form: FormGroup;
  @Input() serviceChargeDetails$: Observable<Classifier[]>;
  @Input() userCanProvideServiceChargeDetails: boolean;
  @Input() serviceChargeDetailsControl: AbstractControl;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}
}
